<template>
    <b-modal ref="modal" :title="title" no-close-on-backdrop @ok="ok()" @cancel="close()" @close="close()">
        <input class="form-control" v-model="value"/>
    </b-modal>
</template>

<script>
export default {
    name: "PromptDialog",
    props: ["title"],
    data() {
        return {
            value: "",
        }
    },
    methods: {
        modal(initValue) {
            this.value = initValue || "";
            return new Promise(resolve => {
                this.resolve = resolve;
                this.$refs.modal.show();
            });
        },
        close() {
            this.resolve && this.resolve();
        },
        ok() {
            this.resolve && this.resolve(this.value);
        },
    },
}
</script>

<style scoped>

</style>
